import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyYen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyYen"><Path d="M5.5 3.5L12 10.9688M12 10.9688L18.5 3.5M12 10.9688V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 14.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 11.5H17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyYen;
